import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function PriceTrackingPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-price-tracking")!;
  return <ArticleLayout article={article} />;
}